import {post} from './http'
const baseUrl = '/api/capwhale/course/search'

// 关键字搜索：按课程/机构
export const searchByKey = v => post(`${baseUrl}/searchByKey`, v.data, v.success, v.error)

// 关键字搜索：获取分类信息POST
export const getCategoryByKey = v => post(`${baseUrl}/getCategoryByKey`, v.data, v.success, v.error)

// 关键字搜索：按课程
export const getCourseByKey = v => post(`${baseUrl}/getCourseByKey`, v.data, v.success, v.error)

// 关键字搜索题库：按分类获取
export const getQuestionbankByKey = v => post(`/api/capwhale/questionbank/search/getQuestionbankByKey`, v.data, v.success, v.error)
// 获取推荐列表 getHotNewsByHours
export const getHotNewsByHours = v => post(`/api/capwhale/course/mob/search/getHotNewsByHours`, v.data, v.success, v.error)
